import React from 'react';
import { FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa';
import { Link as LinkIcon } from 'lucide-react';

export default function ProfileAnalytics({ ai, performanceMetrics, tp }) {
  return (
    <div className="col-12 col-lg-3 d-flex flex-column gap-4">
      {/* AI Performance Analysis Card */}
      <div className="card-dark">
        <div className="fw-bold mb-4 text-white">AI Performance Analysis</div>
        
        <div className="text-center mb-4">
          <div className="cp-ai-ring" style={{ '--score-percentage': `${ai.overall}%` }}> 
            <div className="cp-ai-inner-circle">
              <span className="cp-ai-score-num text-white">{ai.overall}</span> 
              <span className="text-muted cp-ai-score-label">/100</span>
            </div>
          </div>
          <div className="text-muted mb-1 cp-ai-overall-label">Overall Performance Score</div>
          <div className="cp-ai-performer-tag">{ai.label}</div> 
        </div>

        <div className="d-flex flex-column gap-3 mb-3">
          {performanceMetrics.map((item, idx) => (
            <div key={idx} className="d-flex align-items-center gap-2">
              <div className="cp-ai-metric-icon">{item.i}</div>
              <div className="cp-ai-metric-label">{item.l}</div>
              <div className="flex-grow-1">
                <div className="cp-ai-progress-track rounded">
                  <div className="cp-ai-progress-fill" style={{ '--progress-width': `${item.s}%` }}></div> 
                </div>
              </div>
              <div className="text-white text-end" style={{width: '45px', fontSize: '0.8rem'}}>{item.s}/100</div> 
            </div>
          ))}
        </div>
        
        <span className="cp-ai-report-link fw-semibold">View Full AI Report →</span>
      </div>

      {/* Unified Physical Attributes & Social Links Card */}
      <div className="card-dark">
        <div className="row g-3">
          {/* Physical Attributes */}
          <div className="col-12 col-md-6 col-lg-12">
            <div className="fw-bold mb-3 text-white">Physical Attributes</div>
            <ul className="cp-list cp-physical-attributes-list mb-0">
              <li className="cp-list-item"><span className="text-muted">Height</span><span className="text-white">{tp.height ? `${tp.height} cm` : '---'}</span></li>
              <li className="cp-list-item"><span className="text-muted">Weight</span><span className="text-white">{tp.weight ? `${tp.weight} kg` : '---'}</span></li>
              <li className="cp-list-item"><span className="text-muted">Body Type</span><span className="text-white">{tp.bodyType || '---'}</span></li>
              <li className="cp-list-item"><span className="text-muted">Hair</span><span className="text-white">{tp.hairColor || '---'}</span></li>
              <li className="cp-list-item"><span className="text-muted">Eyes</span><span className="text-white">{tp.eyeColour || '---'}</span></li>
              <li className="cp-list-item"><span className="text-muted">Skin Tone</span><span className="text-white">{tp.skinType || '---'}</span></li>
            </ul>
          </div>

          {/* Social & Links */}
          <div className="col-12 col-md-6 col-lg-12 border-top border-md-0 border-lg-top border-secondary pt-3 pt-md-0 pt-lg-3 mt-lg-2">
            <div className="fw-bold mb-3 text-white">Social & Links</div>
            <div className="d-flex flex-column gap-2 cp-social-links-list">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2 text-muted"><FaInstagram size={15}/> Instagram</div>
                <div className="text-white">{tp.instagramProfileUrl ? <a href={tp.instagramProfileUrl} target="_blank" rel="noreferrer" className="text-white text-decoration-none">View Link</a> : 'N/A'}</div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2 text-muted"><LinkIcon size={15}/> IMDb</div>
                <div className="text-white">{tp.imdbUrl ? <a href={tp.imdbUrl} target="_blank" rel="noreferrer" className="text-white text-decoration-none">View Link</a> : 'N/A'}</div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2 text-muted"><FaYoutube size={15}/> YouTube</div>
                <div className="text-white">{tp.youtubeUrl ? <a href={tp.youtubeUrl} target="_blank" rel="noreferrer" className="text-white text-decoration-none">View Link</a> : 'N/A'}</div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2 text-muted"><FaFacebook size={15}/> Facebook</div>
                <div className="text-white">{tp.facebookProfileUrl ? <a href={tp.facebookProfileUrl} target="_blank" rel="noreferrer" className="text-white text-decoration-none">View Link</a> : 'N/A'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}